/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractPageComponent } from '@src/app/shared/form/abstract-page.component';
import { NavRoute } from '@src/app/shared/NavRoute';
import { LoggedInComponent } from '@src/app/pages/home-page-component/logged-in/logged-in.component';
import { AnonymousComponent } from '@src/app/pages/home-page-component/anonymous/anonymous.component';
import { CurrentUserService } from '@src/app/modules/user/current-user.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { buildDate, buildVersion } from '@src/environments/version';

@Component({
    selector: 'app-home-page-component',
    templateUrl: './home-page-component.component.html',
    styleUrls: ['./home-page-component.component.scss'],
    imports: [LoggedInComponent, AnonymousComponent, MatProgressSpinnerModule]
})
export class HomePageComponentComponent extends AbstractPageComponent {

    static readonly navRoute = new NavRoute('home', ()=>HomePageComponentComponent, 'home');
    isReady = false;
    otherPage: HomePageComponentComponent;
    buildDate = buildDate;
    buildVersion = buildVersion;

    constructor() {
        const currentUserSvc = inject(CurrentUserService);

        super();
        currentUserSvc.getCurrentUser().pipe(takeUntilDestroyed()).subscribe( u => {
            this.currentUser = u;
            this.isReady = true;
        });
    }
}
